// ** React Imports
import { useState } from "react";

// ** Redux & Store & Actions
import { useSelector, useDispatch } from "react-redux";
import {
	setLastRecoveryEmailSentTime,
	setRecoverCurrentStep,
} from "store/modules/auth";

// ** Third Party Components
import { toast } from "helpers/toastWrapper";
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Tooltip from "components/layout/Tooltip";

// ** Utils & Helpers
import api from "helpers/ApiClient";

// ** Hooks
import { useBlockResendRecoveryEmail } from "../containers/Recover/hooks/useBlockResendRecoveryEmail";
import { RecoverButtonStyled } from "../styles/RecoverButton.styled";

// #####################################################

const ResendRecoverEmail = ({ email }) => {
	const { t } = useTranslation("landing");
	const dispatch = useDispatch();

	const lastRecoveryEmailSentTime = useSelector(
		(state) => state.auth.recover.lastRecoveryEmailSentTime
	);

	const [isSending, setIsSending] = useState(false);

	// Używamy czasu z Redux store lub aktualny czas jako domyślny
	const initialTimeResend = lastRecoveryEmailSentTime || new Date().getTime();

	const { isResendDisabledByTime, remainingTimeString, remainingTimeNumber } =
		useBlockResendRecoveryEmail({ initialTime: initialTimeResend });

	const sendRecoveryEmail = () => {
		setIsSending(true);
		api.post("/authorization/remember/web", { email })
			.then(() => {
				dispatch(setLastRecoveryEmailSentTime(new Date().getTime()));
				toast.success(t("landing:recover.resendSuccessText"));
			})
			.catch((error) => {
				if (error?.response?.data?.error) {
					toast.error(`${error.response.data.error}`);
				}
			})
			.finally(() => {
				setIsSending(false);
			});
	};

	// #####################################################

	return (
		<Block flex my={4} justifyCenter style={{ gap: "0.5rem" }}>
			<Block flex column justifyCenter alignCenter withRowGap>
				<Tooltip
					text={
						isResendDisabledByTime &&
						remainingTimeString &&
						remainingTimeNumber > 0 &&
						`${t(
							"landing:register.email.resendTooltipText"
						)} ${remainingTimeString}`
					}
				>
					<RecoverButtonStyled
						onClick={() => {
							if (!isResendDisabledByTime && !isSending) {
								sendRecoveryEmail();
							}
						}}
						disabled={isResendDisabledByTime || isSending}
						label={t("landing:register.email:resendLink2")}
					>
						{t("landing:register.email:resendLink2")}
					</RecoverButtonStyled>
				</Tooltip>

				<RecoverButtonStyled
					onClick={() => {
						dispatch(setRecoverCurrentStep("first"));
					}}
					label={t("landing:recover.resetEmail")}
				>
					{t("landing:recover.resetEmail")}
				</RecoverButtonStyled>
			</Block>
		</Block>
	);
};

// #####################################################

export default ResendRecoverEmail;

// #####################################################
